import {FC, useEffect} from 'react';
import classNames from 'classnames';
import InnerImageZoom from 'react-inner-image-zoom';
import {disableScrollOnHtmlNode, enableScrollOnHtmlNode} from 'core/helpers';
import style from './style.module.scss';
import Icon from 'components/Icon';

interface IProps {
    isOpen: boolean;
    image: string | null;
    onClose: () => void;
    isReviewsPage?: boolean;
}

export const MagnifierImagePopup: FC<IProps> = ({isOpen = false, onClose, image, isReviewsPage = false}) => {
    useEffect(() => {
        if (isOpen) {
            disableScrollOnHtmlNode();
        }

        return () => {
            enableScrollOnHtmlNode();
        };
    }, [isOpen]);

    if (!isOpen) {
        return null;
    }

    return (
        <div
            className={classNames(style.imagePopup, 'magnifier-image-popup', {
                [style.imagePopupReviews]: isReviewsPage,
            })}
        >
            <div className={style.overlay} onClick={onClose} />
            <div
                className={classNames(style.imagePopupWrapper, {
                    [style.imagePopupReviews]: isReviewsPage,
                })}
            >
                <button className={style.closeButton} onClick={onClose} type={'button'}>
                    <Icon icon={'close-old'} />
                </button>
                {image && (
                    <InnerImageZoom
                        className={classNames(style.imagePopupInner, {
                            [style.imagePopupReviews]: isReviewsPage,
                        })}
                        fullscreenOnMobile={false}
                        hideCloseButton={true}
                        hideHint={true}
                        moveType={'drag'}
                        src={image}
                        zoomScale={1.5}
                        zoomSrc={image}
                        zoomType={isReviewsPage ? 'hover' : 'click'}
                    />
                )}
            </div>
        </div>
    );
};
